"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../index");
var common_1 = require("./common");
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: tslib_1.__assign({}, diagram, { linkTypeOptions: [
                {
                    '@type': 'LinkTypeOptions',
                    property: 'http://vocabulary.semantic-web.at/cocktail-ontology/image',
                    visible: false,
                },
            ] }),
        validateLinks: true,
        dataProvider: new index_1.SparqlDataProvider({
            endpointUrl: '/sparql',
            imagePropertyUris: [
                'http://vocabulary.semantic-web.at/cocktail-ontology/image',
                'http://vocabulary.semantic-web.at/cocktail-ontology/image_2',
                'http://vocabulary.semantic-web.at/cocktail-ontology/image_3'
                /*
                TODO: find a better way to handle a dynamic URL variable to not have this hardcoded for support with more endpoints
                */
            ],
            queryMethod: index_1.SparqlQueryMethod.GET,
            acceptBlankNodes: true,
            projectIdentifier: 'AllAboutCocktails',
        }, index_1.OWLStatsSettings),
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (iri) { return window.open(iri); },
        groupBy: [
            { linkType: 'http://www.researchspace.org/ontology/group', linkDirection: 'in' },
        ],
    },
    languages: [
        /*
TODO: find a way to get all available languages from the project

SELECT * WHERE{
?s <http://www.semantic-web.at/ppcl/availablelanguages> ?o
}


*/
        { code: 'en', label: 'English' },
    ],
    language: 'en',
    elementTemplateResolver: function (types) {
        if (types.indexOf('http://www.ics.forth.gr/isl/CRMinf/I2_Belief') !== -1) {
            return index_1.GroupTemplate;
        }
        return undefined;
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
